module.exports = __webpack_public_path__ + "static/media/NZ.3c10008b.png";